module.exports = __webpack_public_path__ + "img/top-title.de242dce.png";